// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type B2BContextProperties = {
  partner_id?: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/b2b_context/jsonschema/2-0-0';
export const b2BContextName = 'b2b_context';
export class B2BContext extends BaseTrackingContext<B2BContextProperties> {
  constructor(properties: B2BContextProperties) {
    super(b2BContextName, schema, properties);
  }
}
